module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright-index"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "banner-out-wrapper"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "copyright_banner_bg.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-inner-wrapper"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "large-slogan"
  }, [_vm._v("持续获得影响力和收益")]), _vm._v(" "), _c('span', {
    staticClass: "sub-slogan"
  }, [_vm._v("让你的作品插上声音的翅膀")]), _vm._v(" "), (_vm.$store.state.user.author.authorProgressStatus === 0) ? _c('a', {
    staticClass: "btn-join",
    attrs: {
      "href": _vm.$store.state.DUB_HOST
    }
  }, [_vm._v("立即入驻")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.author.authorProgressStatus === 1) ? _c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("您的资料正在审核中....")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.author.authorProgressStatus === 5) ? _c('div', {
    staticClass: "rejoin-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'copyrighterApply'
      }
    }
  }, [_vm._v("重新入驻")]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "placement": "bottom",
      "effect": "light"
    }
  }, [_c('div', {
    slot: "content"
  }, [_vm._v(_vm._s(_vm.$store.state.user.author.rejectionReason))]), _vm._v(" "), _c('span', {
    staticClass: "rejection-reason"
  }, [_vm._v("查看审核失败原因")])])], 1) : _vm._e()])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "enter-out-wrapper"
  }, [_c('div', {
    staticClass: "enter-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("简单三步轻松入驻")]), _vm._v(" "), _c('div', {
    staticClass: "enter-flow"
  }, [_c('div', {
    staticClass: "flow"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "register_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("1 注册账户")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "next_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "info_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("2 提交资料")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "next_logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('img', {
    attrs: {
      "src": (_vm.IMG_HOST + "pass_audit_logo.png")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v("3 通过审核")])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "production-flow-out-wrapper"
  }, [_c('div', {
    staticClass: "production-flow-bg-wrapper"
  }, [_c('div', {
    staticClass: "production-flow-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("获得长期收益")]), _vm._v(" "), _c('div', {
    staticClass: "production-flow-wrapper"
  }, [_c('div', {
    staticClass: "production-flow"
  }, [_c('i', {
    staticClass: "icon icon-prod-flow-01 icon-28"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("作品销售分成")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("你将获得有声作品产生的销售分成，让作品时刻赚钱")])])]), _vm._v(" "), _c('div', {
    staticClass: "production-flow"
  }, [_c('i', {
    staticClass: "icon icon-prod-flow-02 icon-28"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("广告收入分成")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("平台会引入多种广告模式，让你持续获得广告收入分成")])])]), _vm._v(" "), _c('div', {
    staticClass: "production-flow"
  }, [_c('i', {
    staticClass: "icon icon-prod-flow-03 icon-28"
  }), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("流量红利")]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("喜马拉雅FM拥有4亿用户，在强大的流量带动下，你的纸书、电子书和周边产品将一同获利")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad-out-wrapper"
  }, [_c('div', {
    staticClass: "ad-inner-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("他们已经在平台上获得了巨大的影响力和收益")]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group11/M0A/CB/C0/wKgDa1aDNfbCQ0F-AAQuYGPWMgM050.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("首席医官")]), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v("银河九天 著")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("专辑累计播放量 5.4亿")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group23/M01/15/2B/wKgJL1gYYjzxW7fQAAWaMAvliP8961.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("摸金天师")]), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v("风尘散人 著")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("专辑累计播放量11.5亿")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group18/M04/C5/14/wKgJJVfDl-GS-CPPAAUbRT3EQ6A771.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("雪中悍刀行")]), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v("烽火戏诸侯 著")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("专辑累计播放量1.6亿")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "http://fdfs.xmcdn.com/group8/M05/C8/8D/wKgDYVZqgCKRiQk1AAdB3O60pYc894.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("侯卫东官场笔记")]), _vm._v(" "), _c('span', {
    staticClass: "author"
  }, [_vm._v("小桥老树 著")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("专辑累计播放量3.5亿")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eddf03b0!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/CopyrightIndex.vue
// module id = 335
// module chunks = 0